import { useState } from 'react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { PRESETS } from './k2utils';

const CustomRange = ({ value, onApply }) => {
  const [draft, setDraft] = useState(value);
  const valid = draft.from && draft.to && draft.from <= draft.to;
  const dirty = draft.from !== value.from || draft.to !== value.to;
  return (
    <div className="flex flex-wrap items-center gap-2">
      <Input type="date" value={draft.from} max={draft.to} className="w-36" data-testid="k2-custom-from"
        onChange={(e) => setDraft({ ...draft, from: e.target.value })} />
      <span className="text-[#57534E]">–</span>
      <Input type="date" value={draft.to} min={draft.from} className="w-36" data-testid="k2-custom-to"
        onChange={(e) => setDraft({ ...draft, to: e.target.value })} />
      <Button size="sm" disabled={!valid || !dirty} onClick={() => onApply(draft)} data-testid="k2-custom-apply"
        className="bg-[#16A34A] hover:bg-[#15803D] text-white">Použít</Button>
      {!valid && <span className="text-xs text-[#DC2626]" data-testid="k2-custom-invalid">Datum od musí být před datem do</span>}
    </div>
  );
};

const Seg = ({ options, value, onChange, testPrefix }) => (
  <div className="inline-flex flex-wrap gap-1 p-1 bg-[#F1F5F1] rounded-xl">
    {options.map((o) => (
      <button
        key={o.id}
        type="button"
        onClick={() => onChange(o.id)}
        data-testid={`${testPrefix}-${o.id}`}
        className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
          value === o.id ? 'bg-white text-[#16A34A] shadow-sm' : 'text-[#57534E] hover:text-[#16A34A]'
        }`}
      >
        {o.label}
      </button>
    ))}
  </div>
);

export const MODES = [
  { id: 'compare', label: 'Vs. předchozí období' },
  { id: 'only', label: 'Jen vybrané období' },
  { id: 'weekly', label: 'Po týdnech' },
];

export const VIEWS = [
  { id: 'table', label: 'Tabulka' },
  { id: 'bar', label: 'Sloupcový graf' },
  { id: 'line', label: 'Čárový graf' },
];

const BOOKS = [
  { id: 'all', label: 'Obě řady' },
  { id: '290', label: 'Řada 290' },
  { id: '291', label: 'Řada 291' },
];

export const K2Controls = ({ s, set, warehouses, books = BOOKS }) => (
  <div className="bg-white border border-[#E2E8F0] rounded-2xl p-4 space-y-3 shadow-sm" data-testid="k2-controls">
    <div className="flex flex-wrap items-center gap-3">
      <Seg options={PRESETS} value={s.preset} onChange={(v) => set({ preset: v })} testPrefix="k2-preset" />
      {s.preset === 'custom' && <CustomRange value={s.custom} onApply={(custom) => set({ custom })} />}
    </div>
    <div className="flex flex-wrap items-center gap-3">
      <Seg options={MODES} value={s.mode} onChange={(v) => set({ mode: v })} testPrefix="k2-mode" />
      <Seg options={VIEWS} value={s.view} onChange={(v) => set({ view: v })} testPrefix="k2-view" />
      {books && <Seg options={books} value={s.book} onChange={(v) => set({ book: v })} testPrefix="k2-book" />}
      {warehouses && (
      <select
        value={s.warehouse}
        onChange={(e) => set({ warehouse: e.target.value })}
        data-testid="k2-warehouse-select"
        className="h-9 px-3 rounded-xl border border-[#E2E8F0] bg-white text-sm text-[#1C1917]"
      >
        <option value="all">Všechny sklady</option>
        {warehouses.map((w) => <option key={w} value={w}>{w}</option>)}
      </select>
      )}
    </div>
  </div>
);
